"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapLegend = void 0;
var interaction_1 = require("ol/interaction");
var control_1 = require("ol/control");
var View_1 = require("ol/View");
var Feature_1 = require("ol/Feature");
var Point_1 = require("ol/geom/Point");
var Polygon_1 = require("ol/geom/Polygon");
var LineString_1 = require("ol/geom/LineString");
var Vector_1 = require("ol/layer/Vector");
var Vector_2 = require("ol/source/Vector");
var Map_1 = require("ol/Map");
var MapLegend = /** @class */ (function () {
    function MapLegend(_elementId, _map, _mapStore, _layerGroups) {
        var _this = this;
        this._elementId = _elementId;
        this._map = _map;
        this._mapStore = _mapStore;
        this._layerGroups = _layerGroups;
        this._initialised = false;
        this.init = function () {
            if (!_this._initialised) {
                _this._element = $("#" + _this._elementId);
                _this.addOverlays();
                //set the inital legend state    
                _this.setLegendState();
                _this._map.onLayerVisibilityChanged.subscribe(_this.onOverlayChanged);
                _this._initialised = true;
            }
        };
        this.onOverlayChanged = function (args) {
            _this.setLegendState(args.layerGroupRef, args.visible);
        };
        this.setLegendState = function (layerGroupRef, visible) {
            if (layerGroupRef === void 0) { layerGroupRef = null; }
            if (visible === void 0) { visible = true; }
            for (var _i = 0, _a = _this._layerGroups; _i < _a.length; _i++) {
                var lg = _a[_i];
                if (layerGroupRef === null || lg.ref === layerGroupRef) {
                    var isVisible = ((layerGroupRef === null) ? lg.isVisible(_this._mapStore) || lg.visibleOnLoad : visible);
                    var li = $("#map_legend_li_" + lg.ref);
                    if (isVisible === true) {
                        li.show();
                    }
                    else {
                        li.hide();
                    }
                }
            }
            //show briefly otherwise the follwoign query doesn't work
            _this._element.show();
            //get a count of all the visible li's
            var count = $(".esdm-layer-legend li:visible").length;
            if (count > 0) {
                _this._element.show();
            }
            else {
                _this._element.hide();
            }
        };
        this.addOverlays = function () {
            var self = _this;
            if (!self._elementId) {
                console.warn("MapLegend - missing element id");
                return;
            }
            //add the base layers to the layer switcher
            var ul = $("<ul>", { "class": "esdm-layer-legend" });
            var pnl = $("#" + self._elementId).append(ul);
            if (_this._layerGroups !== null) {
                for (var _i = 0, _a = _this._layerGroups; _i < _a.length; _i++) {
                    var grp = _a[_i];
                    if (grp.displayInLayerSwitcher === true) {
                        var legendMapId = "map_legend_map_" + grp.ref;
                        var legendHtml = "\n                        <li id=\"map_legend_li_" + grp.ref + "\">\n                           <div id=\"map_legend_container_" + grp.ref + "\" class=\"legendContainer\">\n                              <label>" + grp.displayName + "</label>\n                              <div id=\"" + legendMapId + "\" class=\"legendMap\"></div>\n                           </div>\n                        </li>\n                    ";
                        ul.append(legendHtml);
                        //must do the map after the element has been added to the dom
                        self.addLegendMap(legendMapId, grp);
                    }
                }
            }
        };
        this.addLegendMap = function (legendMapId, layerGrp) {
            var newMap = new Map_1.default({
                target: legendMapId,
                controls: control_1.defaults({
                    attribution: false,
                    rotate: false,
                    zoom: false
                }),
                interactions: interaction_1.defaults({
                    altShiftDragRotate: false,
                    dragPan: false,
                    doubleClickZoom: false,
                    keyboard: false,
                    mouseWheelZoom: false,
                    shiftDragZoom: false,
                    pinchZoom: false,
                    pinchRotate: false
                }),
                view: new View_1.default({
                    center: [80, 0],
                    zoom: 16
                })
            });
            var f = [];
            var pos = 1;
            if (layerGrp.layerLegend.point === true) {
                f.push(new Feature_1.default({
                    geometry: new Point_1.default([25, 0])
                }));
                pos += 1;
            }
            if (layerGrp.layerLegend.polygon === true) {
                var x = void 0;
                if (pos === 1) {
                    x = 10;
                }
                else {
                    x = 66;
                }
                f.push(new Feature_1.default({
                    geometry: new Polygon_1.default([[[x, -20], [x, 20], [x + 40, 20], [x + 40, -20], [x, -20]]])
                }));
                pos += 1;
            }
            if (layerGrp.layerLegend.line === true) {
                var x = void 0;
                if (pos === 1) {
                    x = 10;
                }
                else if (pos === 2) {
                    x = 70;
                }
                else {
                    //pos==3
                    x = 130;
                }
                f.push(new Feature_1.default({
                    geometry: new LineString_1.default([[x, 0], [x + 40, 0]])
                }));
            }
            var vl = new Vector_1.default({
                source: new Vector_2.default({
                    features: f
                }),
                style: layerGrp.style
            });
            newMap.addLayer(vl);
        };
        this.init();
    }
    return MapLegend;
}());
exports.MapLegend = MapLegend;
//# sourceMappingURL=MapLegend.js.map